// src/utils/fnctSuivies.ts — SCE Issues
// Suivre une FNC-T (lot 2 du § 14, 22/10) : la même cloche que pour un problème,
// un projet ou un équipement. Pur, testable hors ligne.
//
// Rangement : le bloc `fnctSuivies` du JSON Prefs de SA ligne de SCE_UserPrefs
// (`{ v: 1, numeros: ['FNC-T_2026-57', …] }`) — aucune colonne SharePoint à créer.
// Les messages aux personnes qui suivent (lot F6, 23/10) : c'est l'appli qui
// lit ce bloc sur toutes les lignes et adresse (utils/notificationsFnct) — pas
// de colonne pour Power Automate.
//
// Lecture tolérante : un N° illisible ou en double est écarté, un bloc d'une
// autre forme vaut « rien de suivi ». Comparaison sans la casse ; on garde la
// graphie de la fiche.

import { lireNumero } from './fnct'

export const CLE_BLOC_FNCT_SUIVIES = 'fnctSuivies'

/** Au-delà, la plus ancienne sort : la liste reste lisible et le bloc léger. */
export const MAX_FNCT_SUIVIES = 200

export interface BlocFnctSuivies {
  v: 1
  numeros: string[]
}

const cle = (numero: string): string => numero.trim().toUpperCase()

/** Les N° suivis, dans l'ordre où on les a suivis (le plus ancien d'abord). */
export function lireFnctSuivies(bloc: unknown): string[] {
  if (typeof bloc !== 'object' || bloc === null) return []
  const numeros = (bloc as { numeros?: unknown }).numeros
  if (!Array.isArray(numeros)) return []
  const vus = new Set<string>()
  const res: string[] = []
  for (const n of numeros) {
    if (typeof n !== 'string' || !lireNumero(n.trim())) continue
    const k = cle(n)
    if (vus.has(k)) continue
    vus.add(k)
    res.push(n.trim())
  }
  return res
}

export function suitFnct(liste: readonly string[], numero: string): boolean {
  const k = cle(numero)
  return liste.some((n) => cle(n) === k)
}

/** La liste après un clic sur la cloche : ajouté en fin (la plus ancienne sort au-delà du plafond), ou retiré. */
export function basculerFnctSuivie(liste: readonly string[], numero: string, suivre: boolean): string[] {
  const sans = liste.filter((n) => cle(n) !== cle(numero))
  if (!suivre) return sans
  return [...sans, numero.trim()].slice(-MAX_FNCT_SUIVIES)
}

export function blocFnctSuivies(numeros: readonly string[]): BlocFnctSuivies {
  return { v: 1, numeros: [...numeros] }
}
